export const MAP_COLORS = {
    primaryBlue: "#3FB1CE",
};

export const MAP_THEME = {
    clusterColor: MAP_COLORS.primaryBlue,
    clusterCircleRadius: 15,
    clusterCountFontSize: 12,
    hoveredOpacity: 0.8,
    nonSelectedOpacity: 0.5,
    selectedIconSize: 1.3,
    hoveredIconSize: 1.1,
};

export const MAP_SOURCE_ID = 'deals';

export const MAP_LAYERS = {
    clusters: 'clusters',
    clusterCount: 'cluster-count',
    unclusteredPoint: 'unclustered-point',
    buildings: 'buildings',
} as const;

export const MAP_BEHAVIOR = {
    clusterMaxZoom: 14,
    fitBoundsPadding: 50,
    minZoom: 4,
    maxZoom: 15,
    selectedDealZoom: 13,
    zoomDuration: 800,
};

// Default mapbox marker SVG paths (matches mapboxgl.Marker())
const MARKER_BODY = [
    'M27,13.5C27,19.07 20.25,27 14.75,34.5',
    'C14.02,35.5 12.98,35.5 12.25,34.5',
    'C6.75,27 0,19.22 0,13.5',
    'C0,6.04 6.04,0 13.5,0',
    'C20.96,0 27,6.04 27,13.5Z',
].join('');

const MARKER_OUTLINE = [
    'M13.5,0C6.04,0 0,6.04 0,13.5',
    'C0,19.22 6.75,27 12.25,34.5',
    'C13,35.52 14.02,35.5 14.75,34.5',
    'C20.25,27 27,19.07 27,13.5',
    'C27,6.04 20.96,0 13.5,0Z',
    'M13.5,1C20.42,1 26,6.58 26,13.5',
    'C26,15.9 24.5,19.18 22.22,22.74',
    'C19.95,26.3 16.71,30.14 14.16,33.86',
    'C13.38,34.98 13.64,34.96 12.84,33.86',
    'C10.28,30.14 7.05,26.3 4.78,22.74',
    'C2.5,19.18 1,15.9 1,13.5',
    'C1,6.58 6.58,1 13.5,1Z',
].join('');

const buildMarkerSvg = (bodyFill: string, dotFill: string): string => [
    '<svg display="block" height="41px" width="27px" viewBox="0 0 27 41"',
    ' xmlns="http://www.w3.org/2000/svg">',
    '<defs><radialGradient id="sg">',
    '<stop offset="10%" stop-opacity="0.4"/>',
    '<stop offset="100%" stop-opacity="0.05"/>',
    '</radialGradient></defs>',
    '<ellipse cx="13.5" cy="34.8" rx="10.5" ry="5.25" fill="url(#sg)"/>',
    `<path fill="${bodyFill}" d="${MARKER_BODY}"/>`,
    `<path opacity="0.25" d="${MARKER_OUTLINE}"/>`,
    `<circle fill="${dotFill}" cx="13.5" cy="13.5" r="5.5"/>`,
    '</svg>',
].join('');

export const MARKER = buildMarkerSvg(MAP_COLORS.primaryBlue, 'white');
